import * as React from "react";
import * as ReactDOM from "react-dom/server";

export function getHtmlForExpectedResponse(
  expectedResponses,
  asReact: boolean = true
): any {
  let result = <React.Fragment />;
  if (expectedResponses) {
    result = expectedResponses
      .split(
        /(\bOR\b|\bAND\b|\bNOT\b|\|\||\||&&|\&|(?<=\s|\()or(?=\s|\)|'|"|$)|(?<=\s|\()and(?=\s|\)|'|"|$)|(?<=\s|\()not(?=\s|\)|'|"|$)|<b>\(<\/b>|<\/b>\)|<b>\)<\/b>)(?=(?:[^"]*"[^"]*")*[^"]*$)/g
      )
      .map((el, i) => {
        const elLowercased = el;
        if (
          ["AND", "OR", "NOT", "|", "||", "&", "&&"].includes(elLowercased) &&
          !el.match(/^["'].*["']$/)
        ) {
          return <span key={i}>&nbsp;{el}&nbsp;</span>;
        } else if (elLowercased === "<b>(</b>") {
          return (
            <b className="super-bold" key={i}>
              (
            </b>
          );
        } else if (elLowercased === "<b>)</b>") {
          return (
            <b className="super-bold" key={i}>
              )
            </b>
          );
        } else if (el.trim().length) {
          const tempEl = el.replace(/\"/g, '');
          return (
            <span
              key={i}
              className={`expected-responses__word-item${el?.length > 20 ? " with-dots" : ""
                }`}
            >
              {el.trim() === "_" ? <span>&nbsp;</span> : tempEl}
            </span>
          );
        } else {
          const tempEl = el.replace(/\"/g, '');
          return <span key={i}>{tempEl}</span>;
        }
      });
  }

  if (asReact) {
    return result;
  }

  return ReactDOM.renderToStaticMarkup(result);
}
